// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addProductWithResult } from "@insite/client-framework/Services/CartService";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { customAddProductWithResult } from "@mcmc/App/Services/CustomCartService";

export const CustomSendDataToApi: typeof SendDataToApi = async props => {
    const properties = (props.apiParameter as any).properties;

    try {
        const result =
            properties && properties.isWidgetNonStockItem === "true"
                ? await customAddProductWithResult(props.apiParameter)
                : await addProductWithResult(props.apiParameter);

        if (result.successful) {
            props.apiResult = result.result;
        } else {
            props.dispatch({ type: "Context/CompleteAddingProductToCart" });
            props.parameter.onError?.(result.errorMessage);
            if (result.statusCode === 403) {
                const { isAuthenticated, rememberMe } = props.getState().context.session;
                (isAuthenticated || rememberMe) && window.location.reload();
            }
            return false;
        }
    } catch (e) {
        props.dispatch({ type: "Context/CompleteAddingProductToCart" });
        props.parameter.onError?.(e);
        return false;
    }
};

replaceInChain(chain, SendDataToApi, CustomSendDataToApi);
